import type { ComponentProps } from "react";
import type { Icons } from "./types";

function createIconComponent(svgFileNameWithoutExtension: Icons) {
    // TODO: ugly hack to get icons in php integration working.
    // The build process of the php integration inlines the icons svg sprite. So we need to test if it's there.
    // If yes, reference svg symbols just with '#xxx' instead of a relative path
    const useHref = `${!document.getElementById("maps-svg-sprite") ? "./__spritemap" : ""}#${svgFileNameWithoutExtension}`;

    const component = (props: ComponentProps<"svg">) => (
        <svg
            fill="currentColor"
            preserveAspectRatio="xMidYMid meet"
            role="img"
            {...props}
        >
            <use href={useHref} />
        </svg>
    );

    component.displayName = svgFileNameWithoutExtension;

    return component;
}

export const ArrowDownIcon = createIconComponent("arrow-down");
export const ArrowLeftIcon = createIconComponent("arrow-left");
export const ArrowRightIcon = createIconComponent("arrow-right");
export const CheckIcon = createIconComponent("check");
export const CloseIcon = createIconComponent("close");
export const CloudsIcon = createIconComponent("clouds");
export const CrossIcon = createIconComponent("cross");
export const NoCloudsIcon = createIconComponent("no-clouds");
export const CopyrightIcon = createIconComponent("copyright");
export const DataTemporaryNotAvailableSadFaceIcon = createIconComponent(
    "data-temporary-not-available-sad-face",
);
export const BaseErrorFallbackIcon = createIconComponent("error-fallback");
export const ExpandSizeIcon = createIconComponent("expand-size");
export const LocateMeRoundedIcon = createIconComponent("locate-me-rounded");
export const LocateMeIcon = createIconComponent("locate-me");
export const LocationPinIcon = createIconComponent("location-pin");
export const MinusIcon = createIconComponent("minus");
export const PauseIcon = createIconComponent("pause");
export const PlayIcon = createIconComponent("play");
export const PlusIcon = createIconComponent("plus");
export const PrecipitationIcon = createIconComponent("precipitation");
export const RefreshIcon = createIconComponent("refresh");
export const SearchIcon = createIconComponent("search");
export const SettingsIcon = createIconComponent("settings");
export const SkiAreaPinIcon = createIconComponent("ski-area-pin");
export const SkiIcon = createIconComponent("ski");
export const SliderPointerIcon = createIconComponent("slider-pointer");
export const SnowIcon = createIconComponent("snow");
export const UserLocationPinIcon = createIconComponent("user-location-pin");
export const WindDirectionIcon = createIconComponent("wind-direction");
export const WindIcon = createIconComponent("wind");
/*export const WindGustIcon = createIconComponent("wind-gust");*/
export const NoWarningsIcon = createIconComponent("no-warnings");
export const WarningIcon = createIconComponent("warning");
export const WarningAvalanchesIcon = createIconComponent(
    "warning-group-avalanches",
);
export const WarningDroughtIcon = createIconComponent("warning-group-drought");
export const WarningFogIcon = createIconComponent("warning-group-fog");
export const WarningForstFireIcon = createIconComponent(
    "warning-group-forest-fire",
);
export const WarningFrostIcon = createIconComponent("warning-group-frost");
export const WarningGeneralIcon = createIconComponent("warning-group-general");
export const WarningGlazeIcon = createIconComponent("warning-group-glaze");
export const WarningHailIcon = createIconComponent("warning-group-hail");
export const WarningHeatIcon = createIconComponent("warning-group-heat");
export const WarningLakeIcon = createIconComponent("warning-group-lake");
export const WarningRainIcon = createIconComponent("warning-group-rain");
export const WarningRimeIceIcon = createIconComponent("warning-group-rime-ice");
export const WarningSlipperinessIcon = createIconComponent(
    "warning-group-slipperiness",
);
export const WarningSnowdriftIcon = createIconComponent(
    "warning-group-snowdrift",
);
export const WarningSnowfallIcon = createIconComponent(
    "warning-group-snowfall",
);
export const WarningThawIcon = createIconComponent("warning-group-thaw");
export const WarningThunderstormIcon = createIconComponent(
    "warning-group-thunderstorm",
);
export const WarningTornadoIcon = createIconComponent("warning-group-tornado");
export const WarningUVIcon = createIconComponent("warning-group-uv");
export const WarningWindIcon = createIconComponent("warning-group-wind");
export const DataTemporaryUnavailableLegendBarsIcon = createIconComponent(
    "data-temporary-unavailable-legend-bars",
);
export const DataTemporaryUnavailableLegendAreaIcon = createIconComponent(
    "data-temporary-unavailable-legend-area",
);
export const TooltipArrowIcon = createIconComponent("tooltip-arrow");
export const PollenIcon = createIconComponent("pollen");
